module.exports = __webpack_public_path__ + "static/media/ico-maps.e6a49974.svg";